import {
  CreateAliceCardPaymentMethodMutation,
  CreatePaymentMethodInput,
  useCreateAliceCardPaymentMethodMutation,
  useStripeSetupIntentSecretQuery,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { ConfirmBankAccountSetupResponse } from '../../../externalServices/stripe/useConfirmBankAccount'
import { useOrg } from '../../organization/useOrg'
import { TypedBankableEntity } from './types'

type UseCreateAliceCardPaymentMethodMutationOptions = UseGqlMutationCallbacks<
  CreateAliceCardPaymentMethodMutation,
  ConfirmBankAccountSetupResponse
>

export const useCreateAliceCardPaymentMethod = (
  entity: TypedBankableEntity,
  bankInfo: Pick<CreatePaymentMethodInput, 'routingNumber' | 'accountNumber'>,
  mutationOptions?: UseCreateAliceCardPaymentMethodMutationOptions
) => {
  const { mutateAsync: createPaymentMethod } = useCreateAliceCardPaymentMethodMutation()
  const org = useOrg()
  if (!org) throw new Error('Cannot create payment method without an org')

  const mutationOptionsWithInvalidation = useMutationOptionsWithInvalidation(mutationOptions, [
    useOrg.getKey({ orgId: org.id }),
    useStripeSetupIntentSecretQuery.getKey({ orgId: org.id }),
  ])

  return useMutation(
    ['createAliceCardPayment'],
    ({ paymentMethodId }) =>
      createPaymentMethod({
        input: {
          paymentMethodId,
          accountNumber: bankInfo.accountNumber,
          routingNumber: bankInfo.routingNumber,
          ownerId: entity.id,
          ownerType: entity.type,
        },
      }),
    mutationOptionsWithInvalidation
  )
}
